import ri from "./trigger-condition.js";
export default class ni {
  constructor(t, i) {
    (this.zu = t), (this.Ju = i), (this.zu = t), (this.Ju = i);
  }
  Jl(t) {
    if (null == this.zu) return !1;
    const i = ri.Ku(t[0], this.zu);
    if (!i) return !1;
    let r = null == this.Ju || 0 === this.Ju.length;
    if (null != this.Ju)
      for (let i = 0; i < this.Ju.length; i++)
        if (this.Ju[i] === t[1]) {
          r = !0;
          break;
        }
    return i && r;
  }
  static fromJson(t) {
    return new ni(t ? t.id : null, t ? t.buttons : null);
  }
  Y() {
    return this.zu;
  }
}
